import { Paragraph, H1Title } from "../typography/typography";
import location from "../../assets/images/auth/location.svg";
import Icon from "../icon/icons";


export default function HeroSlider({slides}) {
  return (
    <div className="w-full h-full mx-auto">
      
      {slides.map((s) => (
            <article key={s.id} className="relative h-full rounded-md overflow-hidden shadow-xl ring-1 ring-black/10">
              {/* background image */}
              <img
                src={s.image}
                alt={s.title || ""}
                className="absolute inset-0 h-full w-full object-cover object-center-top"
              />

              {/* dark gradient overlay for readability */}
              <div className="absolute inset-0 bg-gradient-to-t from-black from-8% to-transparent rounded-md" />

              {/* top kicker pill */}
              {s.kicker && (
                <div className="absolute left-5 top-6 z-10">
                  <span className="inline-flex items-center gap-2 rounded-full bg-black/60 px-4 py-1.5 text-sm font-medium text-white backdrop-blur">
                    <img src={location} className="w-4 xl:w-5" alt="" />
                    {s.kicker}
                  </span>
                </div>
              )}

              {/* caption + bullets box */}
              <div className="absolute inset-x-5 bottom-10 z-10 text-white max-w-xl">
                <H1Title
                  className="font-medium text-white"
                  size="lg"
                >
                  {s.title}
                </H1Title>

                {s.description && (
                  <Paragraph
                    size="base"
                    className="mt-3 text-white/70 font-normal"
                  >
                    {s.description}
                  </Paragraph>
                )}

                {Array.isArray(s.list) && s.list.length > 0 && (
                  <div className="mt-6 y-4 ">
                    <ul className="space-y-3">
                      {s.list.map((item, index) => (
                        <li key={index} className="flex items-center gap-3">
                          <span className="flex h-7 w-7 items-center justify-center rounded-full">
                            <Icon name="checker" iconClass="w-3.5 h-3.5 text-black" />
                          </span>
                          <Paragraph
                            size="sm"
                            className="text-white font-medium text-left"
                          >
                            {item}
                          </Paragraph>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </article>
        ))}
    </div>
  );
}
